<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('admin.list_manager.export_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <div class="flex">
            <div class="w-1/2 pr-4">
                <ui-label data-cy="admin-list-manager-export-association-label">{{
                    $t('admin.list_manager.form.labels.association')
                }}</ui-label>
                <a-select
                    data-cy="admin-list-manager-export-association-select"
                    :placeholder="$t('admin.list_manager.form.labels.association')"
                    class="mt-2"
                    show-search
                    style="width: 100%"
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    @change="handleFilterChange"
                    :allowClear="true"
                >
                    <a-select-option v-for="(value, index) in associationList" :key="index" :value="index">
                        {{ value.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="w-1/2 pr-4">
                <ui-label data-cy="admin-list-manager-export-category-label">{{
                    $t('admin.list_manager.form.labels.category')
                }}</ui-label>
                <ui-select
                    data-cy="admin-list-manager-export-category-select"
                    :placeholder="$t('admin.list_manager.form.labels.category')"
                    class="mt-2"
                    style="width: 100%"
                    v-model="category"
                    :options="categories"
                    :allowClear="true"
                />
            </div>
        </div>
        <ui-checkbox
            data-cy="admin-list-manager-export-include-association-id"
            class="mt-2"
            :disabled="association_id"
            v-model="include_association_id"
        >
            {{ $t('admin.list_manager.form.labels.include_association_id') }}
        </ui-checkbox>
        <template #footer>
            <a-button
                data-cy="admin-list-manager-export-submit"
                key="submit"
                type="primary"
                :disabled="category == undefined && association_id == null"
                :loading="processing"
                @click="handleSubmit"
            >
                {{ $t('admin.list_manager.form.buttons.export') }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';
import UiSelect from '@/components/ui/Select.vue';
import UiCheckbox from '@/components/ui/Checkbox.vue';

export default {
    components: { UiLabel, UiSelect, UiCheckbox },
    data() {
        return {
            categories: [],
            association_id: null,
            category: undefined,
            modal_visible: false,
            include_association_id: false,
            associationList: [],
        };
    },
    mounted() {
        this.$http.get('/api/listmanagermeta/categories').then((response) => {
            this.categories = [];

            response.data.data.forEach((record) => {
                this.categories.push({
                    text: record.list_name,
                    value: record.category,
                });
            });
        });
        this.$http
            .get('/api/admin/list-associations')
            .then((response) => {
                this.associationList = response.data.data;
            })
            .catch((error) => {
                this.$notification.error({
                    message: this.$t('globals.global.notifications.error.any', { code: 'CVAL01' }),
                });
            });
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        handleSubmit() {
            let include_association_id = this.include_association_id;
            if (this.association_id) {
                include_association_id = null;
            }
            this.$emit('formSubmit', {
                include_association_id: include_association_id,
                association_id: this.association_id,
                category: this.category,
            });
        },
        handleFilterChange(value) {
            this.association_id = null;

            if (value != undefined) {
                this.association_id = this.associationList[value].id;
            }
        },
        filterOption(input, option) {
            return option.children()[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
    },
};
</script>
